(function($){

  var checkTimer;

  $(document).ready(function(){

    console.log('Sunside Studio (https://sunsidestudio.com): Developed with ❤️ + ☕ || Another ONE by Jayanetty [https://jayanetty.com/]');

    $('.home-collection-overlay-wrapper').click(function(){
      location.href = $(this).data('url');
    });

    $('.footer-linklist .section-title').click(function(){
      if (!$(this).parent().hasClass('open')) {
        $(this).parent().find('ul').slideDown();
        $(this).parent().addClass('open');
      } else {
        $(this).parent().find('ul').slideUp();
        $(this).parent().removeClass('open');
      }
    });if (!Cookies.get('nlpu')) {
      setTimeout(function(){
        $('.mailing-list.popup').fadeIn();
      }, 5000);
    }$('.mailing-list.popup .close').click(function(){
      Cookies.set('nlpu', '1', { expires: 30 });
      $(this).parent().fadeOut('slow');
    });

    $('.mailing-list.popup #contact_form').submit(function(){
      Cookies.set('nlpu', '1', { expires: 30 });
    });

    $('.home-masonry-feature-6, .home-masonry-feature-6 a').click(function(){
      $('.mailing-list.popup').fadeIn();
      return false;
    });

    $('.nav-btn.search').click(function(){
      if ($(window).width() > 1079) {
        if ($('.main-header').hasClass('header-search-expanded') && $('.navigation-set-wrapper .header-search-input').val()) {
          $('.navigation-set-wrapper .header-search-form').submit();
          return false;
        } else {
          $('.main-header').toggleClass('header-search-expanded');
        }
      } else {
        $('.navigation-wrapper.mobile .header-search-form').submit();
      }
    });

    $('.navigation-set-wrapper .header-search-input').keypress(function (e) {
     var key = e.which;
     if(key == 13)  // the enter key code
      {
        $('.navigation-set-wrapper .header-search-form').submit();
        return false;
      }
    });

    if ($(window).width() > 1079) {
      setTimeout(
        function(){
          $('.blog-post-inner').css('padding-top',$('.blog-post .highlight').height() - 65);
        }, 1000);
    }

    if ($('.home-slideshow-slide').length == 1) {
      $('.home-slideshow').addClass('one-slide');
    }

    $('.navigation-mobile .navigation-menu-link').click(function(){
      if ($(this).attr('href') == '#') {
        $(this).parent().toggleClass('has-dropdown-open');
        $(this).next().toggleClass('navigation-submenu-visible');
      }
    });
  });

  $(window).resize(function(){

    $('.home-blog-post-image').each(function(){
      $(this).height($(this).width());
    });

    if ($('body.template-page-our-story').length) {
      $('.home-blog-post-image').each(function(){
        $(this).height($(this).width() * 1.51125402);
      });
    }

    if ($('.currency-wrapper').length > 1) {
      $('.currency-wrapper').each(function(index){
        if (index != 0) {$(this).remove();}
      });
    }

    if ($(window).width() < 1080) {
      $('.main-header').removeClass('header-search-expanded');
    }

    if ($(window).width() > 1079) {
      $('.blog-post-inner').css('padding-top',$('.blog-post .highlight').height() - 65);

      $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').width($(window).width());

      clearTimeout(checkTimer);
      checkTimer = setTimeout(CheckMegaMenuOffset, 400);
    }

    if ($('body.template-product').length) {
      if ($(window).width() > 769) {
        $('.product-thumbnails.has-side-scroll').height($('.product-details-wrapper').height());
      } else {
        $('.product-thumbnails.has-side-scroll').height('');
      }
    }

  }).resize();

  function CheckMegaMenuOffset(){
    $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').addClass('visible');

    var megaMenuOffset = $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').offset().left;

    if (megaMenuOffset != 0) {
      AdjustMegaMenuOffset();
    } else {
      $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').removeClass('visible');
    }
  }

  function AdjustMegaMenuOffset(){
    $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').css('margin-left','');

    var megaMenuOffset = $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').offset().left;

    $('.navigation-set-wrapper ul.navigation-submenu.navigation-submenu-tier2').css('margin-left',(megaMenuOffset * -1));

    CheckMegaMenuOffset();
  }

})(jQuery);
